import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
import Badge from "@insite/mobius/Badge";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { css } from "styled-components";

interface Props {
    badgeList: BadgeModel[];
    maxBadges: number;
    extendedStyles?: ProductTextBadgesStyles;
}

export interface ProductTextBadgesStyles {
    container?: InjectableCss;
    badge?: InjectableCss;
    badgeText?: TypographyPresentationProps;
}

export const productTextBadgesStyles: ProductTextBadgesStyles = {
    container: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                ])};
        `,
    },
    badge: {
        css: css`
            margin-top: 5px;
            margin-bottom: 5px;
        `,
    },
    badgeText: {
        size: 13,
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        font-size: 11px;
                    `,
                    css`
                        font-size: 11px;
                    `,
                    null,
                ])}
        `,
    },
};

const ProductTextBadges = ({ badgeList, maxBadges, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(productTextBadgesStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.container} data-test-selector="textBadges">
            {badgeList.slice(0, maxBadges).map(badge => (
                <StyledWrapper key={badge.id} {...styles.badge}>
                    <Badge
                        type={badge.badgeType}
                        value={badge.displayText}
                        badgeTextColor={badge.textColorHexCode}
                        badgeBackgroundColor={badge.badgeColorHexCode}
                        badgeTextRounding={badge.badgeStyle === "Round" ? 20 : 0}
                        textBadgeCss={styles.badgeText}
                        {...styles.badge}
                    />
                </StyledWrapper>
            ))}
        </StyledWrapper>
    );
};

export default ProductTextBadges;
